import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as trackingDataActions from '../../../../actions/trackingDataActions';
import * as appHelper from '../../../../helpers/appHelper';
import * as objectConstants from '../../../../constants/objectConstants';
import * as keyboardConstants from '../../../../constants/keyboardConstants';

import {TweenLite, Elastic, Bounce, Expo} from 'gsap';
import gsap from 'gsap-react-plugin';

class ConversationSingleAnswerOptionReview extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            lang: this.props.lang,
            option: this.props.option,
            locale: appHelper.getLocalData(this.props.option),
            responseData: this.props.responseData,
            focusedOption: this.props.focusedOption,
            focusedClass:"not-focused",
        };
        this.showOption = this.showOption.bind(this);
        this.onObjectSelected = this.onObjectSelected.bind(this);
        this.getDisabledState = this.getDisabledState.bind(this);
        this.getOptionClass = this.getOptionClass.bind(this);
        this.handleOptionVisibility = this.handleOptionVisibility.bind(this);
        this.setFocus = this.setFocus.bind(this);
        this.setBlur = this.setBlur.bind(this);
    }

    componentDidMount() {
        this.handleOptionVisibility();
    }

    componentWillReceiveProps(nextProps) {
        if (this.state.responseData !== nextProps.responseData) {
            this.setState({responseData: nextProps.responseData});
        }

        if (this.state.focusedOption !== nextProps.focusedOption) {
            this.setState({focusedOption: Object.assign({}, nextProps.focusedOption)});
        }

        if(this.state.lang !== nextProps.lang){
            this.setState({
                lang: nextProps.lang,
                locale: appHelper.getLocalData(this.state.option)
            });
        }
    }

    componentDidUpdate() {
        this.handleOptionVisibility();
    }

    getOptionClass() {
        let responseData = this.state.responseData;
        let latestResponse = appHelper.getLastItemOfArray(responseData.responses);
        let activeClass = "";
        if (this.props.optionReviewId === this.state.option.option_id) {
            activeClass = "review-current";
        }
        if ((responseData.currentAttempt === responseData.responses.length) && (latestResponse.selectedOption.option_id === this.state.option.option_id)) {
            return `review-selected ${this.state.option.result} ${activeClass}`;
        } else {
            return `review ${this.state.option.result} ${activeClass}`;
        }
    }


    getDisabledState() {
        return `disabled`;
    }

    handleOptionVisibility() {
        this.showOption(0, 0);
    }

    showOption(duration, delay) {
        let optionRef = this.refs[this.state.option.option_id];
        if (appHelper.isDefined(optionRef)) {
            TweenLite.set(optionRef, {height: "auto", opacity: 1});
            TweenLite.from(optionRef, duration, {
                height: 0,
                opacity: 0,
                delay: delay,
                ease: Expo.easeInOut
            });
        }
    }

    onObjectSelected() {
        this.props.onOptionClick(this.state.option);
    }

    setFocus(){
        this.setState({focusedClass:"focused"});
    }
    setBlur(){
        this.setState({focusedClass:"not-focused"});
    }

    render() {

        return (
            <div className={`learner-action-option speak  ${this.getOptionClass()} ${this.state.focusedClass}`}
                 ref={this.state.option.option_id}
                 id={`option_review_${this.state.option.option_id}`}
                 onKeyDown={this.props.optionCallbacks.setKeyboardAccessibility}
                 onFocus={this.setFocus}
                 onBlur={this.setBlur}
                 role="radio"
                 tabIndex={this.state.focusedOption.option_id === this.state.option.option_id ? 0 : -1}
                 aria-checked={this.props.optionReviewId === this.state.option.option_id}
                 aria-disabled="false">

                <label htmlFor={`${this.props.asset_id}_${this.state.option.option_id}_review`}>
                    <input id={`${this.props.asset_id}_${this.state.option.option_id}_review`} type="radio"
                           name={`${this.props.asset_id}_review`}
                           value={this.state.option.option_id}
                           onClick={this.onObjectSelected}

                    />
                    <span dangerouslySetInnerHTML={{__html: this.state.locale.option}}/>
					<span className="hidden-el">{appHelper.getOptionResultString(this.state.option.result,false)}</span>
                </label>
            </div>

        );

    }
}

ConversationSingleAnswerOptionReview.propTypes = {
    option: PropTypes.object.isRequired,
    asset_id: PropTypes.number.isRequired,
    responseData: PropTypes.object.isRequired,
    optionReviewId: PropTypes.number,
    onOptionClick: PropTypes.func,
    focusedOption: PropTypes.object,
    contentData: PropTypes.object,
    trackingData: PropTypes.object,
    optionCallbacks: PropTypes.object,
    lang: PropTypes.string.isRequired,
    actions: PropTypes.object
};

ConversationSingleAnswerOptionReview.contextTypes = {
    router: PropTypes.object
};

function mapStateToProps(state, ownProps) {
    let lang = state.userData.lang;
    return {
        lang:lang,
        contentData: state.contentData,
        trackingData: state.trackingData
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign({}, trackingDataActions), dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(ConversationSingleAnswerOptionReview);



/** WEBPACK FOOTER **
 ** ./src/components/objects/multipleChoice/conversationSingleAnswer/ConversationSingleAnswerOptionReview.js
 **/